import { GridItem, IdNumberInputField } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";

type SocialSecurityNumberCheckField =
  components["schemas"]["SocialSecurityNumberCheckField"];

export function SocialSecurityNumberInputField({
  field: config,
}: {
  field: SocialSecurityNumberCheckField;
}) {
  return (
    <GridItem>
      <IdNumberInputField country="US" name={config.name} isRequired />
    </GridItem>
  );
}
